import { safeDefine } from "@breuni-ui/safe-define";
import RecoLoader from "./RecoLoader";
import RecoConsent from "./RecoConsent";
import RichRelevanceTracking from "./tracking/richRelevance/RichRelevanceTracking";
import { fetchRecommendations } from "./fetchRecommendations";

const recoLoaderTagName = "entd-single-instance-reco-loader" as const;

export default class SingleInstanceRecoLoader extends RecoLoader {
  connectedCallback(): void {
    super.connectedCallback();
    RecoConsent.setupQueue();
    this.richRelevanceConsent = RecoConsent.getRichRelevanceConsent();
    this.personalisierungConsent = RecoConsent.getPersonalisierungConsent();

    if (
      this.recoLoaderProps &&
      this.recoLoaderProps.countryUrlPrefix &&
      this.recoLoaderProps.placement
    ) {
      const placement = this.recoLoaderProps.placement;
      const origin = window.location.origin;
      const countryPrefix = this.recoLoaderProps.countryUrlPrefix;
      RichRelevanceTracking.sendTrackingInfo(
        this.richRelevanceConsent,
        countryPrefix,
        origin,
      );
      fetchRecommendations(window.fetch)(
        [this.recoLoaderProps.placement],
        countryPrefix,
        this.recoLoaderProps.queryParameters,
        origin,
        this.richRelevanceConsent,
        this.personalisierungConsent,
        null,
      )
        .then((resp) => resp[placement])
        .then((recoHtml) => this.renderRecommendation(recoHtml))
        .then((res) => {
          if (this.recoLoaderProps?.aktionsFlagsEnabled) {
            document.dispatchEvent(this.campAktionsflagsInitialized);
          }
          return res;
        })
        .catch(() => this.renderRecommendation(""));
    }
  }
}

safeDefine(recoLoaderTagName, SingleInstanceRecoLoader);
